import React, { FC } from 'react';
import classNames from 'classnames';
import { CatRecords } from '@/api/catList';
import './index.less';
import {
  getOssImageUrl,
  getVideoCoverUrl,
  jumpToAppConfigUrl,
} from '@/utils/utils';
import Videocz from '../video';
import { baseAppPath, DOWNLOAD_IMG } from '@/constants/config';
import { catListUBT } from '@/utils/pageUbt';

interface IProps {
  data: CatRecords;
  businessId?: string;
}

const getBackground = (str: string) => {
  if (/https?:\/\//.test(str)) {
    return `url(${str}) no-repeat`;
  }
  if (str.includes(',')) {
    const colors = str.split(',');
    return `linear-gradient(
          180deg,
          ${colors[0]} 0%,
          ${colors[1]} 100%
        )`;
  }
  return str;
};

const CatListItem: FC<IProps> = (props) => {
  const { data = {}, businessId = '' } = props;

  const jumpToApplyDetail = (
    buttonName: string,
    sponsorid: (string | undefined)[] = [],
    id = ''
  ) => {
    catListUBT.clickButton({
      businessInfo: {
        cat_id: data.id,
        status: data.assistStatus,
        sponsored: sponsorid?.length > 0,
        sponsorid: sponsorid?.join(','),
      },
      buttonName,
    });
    if (id) {
      if (buttonName === 'miaowa_app_catlist_cat_cli') {
        const appCatDetail = `${baseAppPath}pages/cathouse/cat-detail/cat-detail%3FcatId%3D${id}%26source%3Dcat_list%26catHouseId%3D${businessId}%26traceId%3D116e9327115a&disabledSocket=1&traceId=116e9327115a`;
        jumpToAppConfigUrl(appCatDetail);
      } else {
        const appWishList = `${baseAppPath}pages/rescue/wish-list-home/wish-list-home%3FapplyOrderId%3D${id}%26wishSource%3Dcat_list%26traceId%3Dc001042fc006&disabledSocket=1&traceId=c001042fc006`;
        jumpToAppConfigUrl(appWishList);
      }
    }
  };
  const renderSub = (subText: string, progress: number) => {
    if (subText) {
      return subText;
    }
    return (
      <div className="cat_list_item_bottom_process_left_sub_process">
        <div className="cat_list_item_bottom_process_left_sub_process_view">
          <div
            className="cat_list_item_bottom_process_left_sub_process_view_black"
            style={{
              width: `${progress || 0}%`,
            }}
          ></div>
        </div>
        <div className="cat_list_item_bottom_process_left_sub_process_text">
          助力进度{progress}%
        </div>
      </div>
    );
  };

  const regAvatarAssess = (value: string) => {
    const reg =
      /((m.hellobike.com)|(pet-miaowa.51downapp.cn)|(pet-worm.51downapp.cn))/;
    return reg.test(value)
      ? getOssImageUrl(value, 208, undefined, undefined, 60)
      : value;
  };

  const {
    sterilizationProgressInfo,
    avatar = '',
    name = '',
    date = '',
    varietyText = '',
    sexText = '',
    sterilizationStateText = '',
    recommendContentList = [],
    background:
      topBg = 'https://m.hellobike.com/resource/gallery/64/dsc2aaul_taichi_image.png',
  } = data || {};
  const {
    background = '#FFCC00',
    mainText = '',
    subText = '',
    progress = 0,
    buttonText = '',
    assistanceList = [],
  } = sterilizationProgressInfo || {};
  const sponsorid = assistanceList.map((item) => {
    if (+item.type === 1) {
      return item.userId;
    }
    return '';
  });
  return (
    <div
      className="cat_list_item"
      data-id={data?.id}
      data-sponsorid={JSON.stringify(sponsorid)}
      data-assiststatus={data.assistStatus}
      style={{
        marginBottom: sterilizationProgressInfo ? '-18px' : '0',
      }}
    >
      <div
        className="cat_list_item_top"
        onClick={() =>
          jumpToApplyDetail('miaowa_app_catlist_cat_cli', sponsorid, data.id)
        }
        style={{
          marginBottom: sterilizationProgressInfo ? '6px' : '12px',
        }}
      >
        <div className="cat_list_item_top_header">
          <div className="cat_list_item_top_header_left">
            <img
              src={getOssImageUrl(
                'https://m.hellobike.com/resource/gallery/64/dWlrR0KG_taichi_image.png',
                46,
                40
              )}
            />
            <span>ID Card</span>
          </div>
          {/* <div className="cat_list_item_top_header_right">ID No.{labelId}</div> */}
        </div>
        <div className="cat_list_item_top_info">
          {['mp4', 'MP4'].some((item) => avatar.includes(item)) ? (
            <div className="cat_list_item_top_info_left">
              <Videocz
                videoId={`cat_item_${data?.id}`}
                src={avatar || ''}
                poster={getVideoCoverUrl(avatar || '', 750, 428)}
                showCenterBtn
                showController={false}
                showBottomProgress
                pauseBtn={''}
                isLazy
                cover={true}
                playBtn={DOWNLOAD_IMG.PAUSE_BTN}
              />
            </div>
          ) : (
            <div className="cat_list_item_top_info_left">
              <img
                className="top_info_left_media"
                src={regAvatarAssess(avatar)}
              />
            </div>
          )}
          <div className="cat_list_item_top_info_right">
            <div className="cat_list_item_top_info_right_one cat_list_item_top_info_right_f">
              <div className="cat_list_item_top_info_right_item">
                <div className="cat_list_item_top_info_right_label">
                  姓名/NAME
                </div>
                <div className="cat_list_item_top_info_right_value">{name}</div>
              </div>
              <div className="cat_list_item_top_info_right_item">
                <div className="cat_list_item_top_info_right_label">
                  办证时间/DATE
                </div>
                <div className="cat_list_item_top_info_right_value">{date}</div>
              </div>
            </div>
            <div className="cat_list_item_top_info_right_two cat_list_item_top_info_right_f">
              <div className="cat_list_item_top_info_right_item">
                <div className="cat_list_item_top_info_right_label">
                  品种/BREED
                </div>
                <div className="cat_list_item_top_info_right_value">
                  {varietyText}
                </div>
              </div>
              <div className="cat_list_item_top_info_right_item">
                <div className="cat_list_item_top_info_right_label">
                  性别/SEX
                </div>
                <div className="cat_list_item_top_info_right_value">
                  {sexText}
                </div>
              </div>
              <div className="cat_list_item_top_info_right_item">
                <div className="cat_list_item_top_info_right_label">
                  绝育状态/STATUS
                </div>
                <div className="cat_list_item_top_info_right_value">
                  {sterilizationStateText}
                </div>
              </div>
            </div>
            <div className="cat_list_item_top_info_right_three">
              {recommendContentList.map((item: string, index: number) => (
                <div
                  key={`cat_list_item_top_info_right_three_item${index}`}
                  className="cat_list_item_top_info_right_three_item"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {sterilizationProgressInfo && (
        <div
          className="cat_list_item_bottom"
          onClick={(e) => {
            e.stopPropagation();
            jumpToApplyDetail(
              'miaowa_app_catlist_cat_button_cli',
              sponsorid,
              sterilizationProgressInfo.crowdFundOrderId
            );
          }}
          style={{
            background: getBackground(background),
            backgroundSize: '100% 100%',
          }}
        >
          <div className="cat_list_item_bottom_process">
            <div className="cat_list_item_bottom_process_left">
              <div className="cat_list_item_bottom_process_left_main">
                {mainText}
              </div>
              <div className="cat_list_item_bottom_process_left_sub">
                {renderSub(subText, progress)}
              </div>
            </div>
            <div className="cat_list_item_bottom_process_right">
              {buttonText}
              <img
                src={getOssImageUrl(
                  'https://m.hellobike.com/resource/gallery/64/9SfmbmSh_taichi_image.png',
                  18,
                  18
                )}
              />
            </div>
          </div>
          {assistanceList && assistanceList.length > 0 && (
            <div className="cat_list_item_bottom_assistance">
              <div
                className="cat_list_item_bottom_assistance_ui"
                // style={{
                //   animation: `alternateAni ${
                //     assistanceList.length * 2 * 5
                //   }s linear infinite`,
                // }}
              >
                {/* 动画更丝滑 */}
                {assistanceList.slice(0, 1).map((item, index: number) => (
                  <div
                    key={`cat_list_item_bottom_assistance_item${index}`}
                    className={classNames(
                      'cat_list_item_bottom_assistance_item',
                      {
                        cat_list_item_bottom_assistance_item_no:
                          item.type !== 1,
                      }
                    )}
                    style={{
                      background: getBackground(item.background || ''),
                      backgroundSize: '100% 100%',
                    }}
                  >
                    <img src={getOssImageUrl(item.image || '', 28, 28)} />
                    {item.content}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CatListItem;
